module.exports = __webpack_public_path__ + "media/cheney/CheneyCircleLogo48-3b2f73ce.png";